module.exports = __webpack_public_path__ + "img/1185x407px.1d6a9489.jpg";